/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable jsdoc/match-description */

enum MESSAGES {
    ERROR = 'ERROR',
    MODULE_CHANGE = 'MODULE_CHANGE',
    MODULE_CHANGE_REQUEST = 'MODULE_CHANGE_REQUEST',
    NAVIGATE_TO_LANDING_REQUEST = 'NAVIGATE_TO_LANDING_REQUEST',
    LOADING_SPINNER_REQUEST = 'LOADING_SPINNER_REQUEST',
    SET_CURRENT_CLASS_GROUP = 'SET_CURRENT_CLASS_GROUP',
    LOGOUT_REQUEST = 'LOGOUT_REQUEST',
    MAKE_API_CALL = 'MAKE_API_CALL',
    DUCS_EVENT_MODAL = 'DUCS_EVENT_MODAL',
    SET_DYNAMIC_PARAMS = 'SET_DYNAMIC_PARAMS'
}

// Add more messages here
type ApiType = 'Notification';

type ClassGroup = { classId: string; groupId?: string };

const portalCommunication = {
    // The list of shared magic string codes. Used privately here, publicly by the portal to interpret incoming messages
    MESSAGES,

    // eslint-disable-next-line @typescript-eslint/ban-types
    postPortalMessage (message: { type: MESSAGES; message?: string | boolean | string[] | unknown; params?: {} }) {
        // @ts-ignore
        top.postMessage(JSON.stringify(message), '*');
    },

    informClassGroupSelection (classId: string, groupId: string) {
        portalCommunication.postPortalMessage({
            type: portalCommunication.MESSAGES.SET_CURRENT_CLASS_GROUP,
            params: {
                classId,
                groupId
            }
        });
    },
    /**
     * Inform the portal that the currently selected module has changed (For example, you have moved from route to another internally)
     *
     * @param newModuleId
     */
    informModuleChange (newModuleId: string) {
        portalCommunication.postPortalMessage({
            type: portalCommunication.MESSAGES.MODULE_CHANGE,
            message: newModuleId
        });
    },

    /**
     * Inform the portal to go back to portal landing screen for currently loaded
     * module
     *
     * @param moduleId
     */
    requestNavigateToLanding (moduleId: string) {
        portalCommunication.postPortalMessage({
            type: portalCommunication.MESSAGES.NAVIGATE_TO_LANDING_REQUEST,
            message: moduleId
        });
    },

    /**
     * Ask the portal to change the currently selected module, optionally selecting a class/group at the same time
     *
     * @param newModuleId
     * @param [params] {object} An object containing the classId and (optionally) the groupId to select
     */
    requestModuleChange (newModuleId: string, params: ClassGroup) {
        portalCommunication.postPortalMessage({
            type: portalCommunication.MESSAGES.MODULE_CHANGE_REQUEST,
            message: newModuleId,
            params
        });
    },

    /**
     * Show or hide the loading spinner. This should be called with false on every route that can be accessed by the
     * portal, and then turned on/off as needed
     *
     * @param isLoading {boolean} True shows the spinner, false hides it
     */
    requestLoadingSpinner (isLoading: boolean) {
        portalCommunication.postPortalMessage({
            type: portalCommunication.MESSAGES.LOADING_SPINNER_REQUEST,
            message: isLoading
        });
    },

    /**
     * Request the portal alert the user of a server error (Unexpected 500)
     */
    requestServerError () {
        portalCommunication.postPortalMessage({
            type: portalCommunication.MESSAGES.ERROR,
            message: '_SERVER_ERROR_'
        });
    },

    /**
     * Request the portal alert the user to an expired token error
     */
    requestSessionError () {
        portalCommunication.postPortalMessage({
            type: portalCommunication.MESSAGES.ERROR,
            message: '_SESSION_EXPIRED_'
        });
    },

    /**
     * Request the portal to logout
     *
     * @param logoutUrl
     */
    logout (logoutUrl: string) {
        portalCommunication.postPortalMessage({
            type: portalCommunication.MESSAGES.LOGOUT_REQUEST,
            message: logoutUrl
        });
    },

    /**
     * Inform the portal to make an api call based on apiType
     *
     * @param [params] {object} An object containing the productId and apiType to select
     */
    informMakeAPICall (params: { productId: string; apiType: ApiType }) {
        portalCommunication.postPortalMessage({
            type: portalCommunication.MESSAGES.MAKE_API_CALL,
            params
        });
    },

    /**
     * Request the portal to open ducs event modal
     */
    requestDucsModal: (arrayGirlId: string[]) => {
        portalCommunication.postPortalMessage({
            type: portalCommunication.MESSAGES.DUCS_EVENT_MODAL,
            message: arrayGirlId
        });
    },
    setDynamicParams ({
        id, value
    }: { id: string; value: any }) {
        portalCommunication.postPortalMessage({
            type: MESSAGES.SET_DYNAMIC_PARAMS,
            message: { [id]: value }
        });
    }
};

export default portalCommunication;
